package com.gastoncantera.intercom

import web.navigator.navigator

class JsPlatform : Platform {
    private val userAgent = navigator.userAgent
    private val browserList = listOf("Chrome", "Firefox", "Safari", "Edge")

    private val browser: String = userAgent.findAnyOf(browserList, ignoreCase = true)
        ?.let { (startIndex) -> userAgent.substring(startIndex).substringBefore(" ") }
        ?: "Navegador"

    override val name: String = (navigator.asDynamic().platform as? String)
        ?.takeIf { it.isNotBlank() }
        ?.let { "$browser · $it" }
        ?: browser
    override val id: String = "web"
}

actual fun getPlatform(): Platform = JsPlatform()

actual fun isVideoSupportedInEmulator() = true

actual fun isEmulator() = false
